<div kalDialogHeader>

    <div class="kal-dialog__title">Sélection des actions</div>

</div>

<div [kalLoading]="loading"
     kalDialogContent>

    <div *ngFor="let category of categoriesList">

        <span class="gup-U-stronger">
            {{ category.label }}
        </span>

        <div *ngFor="let applicationParameter of category.applicationParametersFormsList; index as i">

            <kal-checkbox [formControl]="applicationParameter.get('selected')"
                          [label]="applicationParameter.value.label">
            </kal-checkbox>

        </div>

    </div>

    <div>
          <span class="gup-U-stronger">
        Options
    </span>

        <div>

            <kal-checkbox [formControl]="shouldDisplayDialogControl"
                          label="Conserver ces paramètres et ne plus afficher cette fenêtre.">
            </kal-checkbox>

        </div>
    </div>


</div>

<div kalDialogFooter>

    <div class="gup-C-validationArea gup-O-list">

        <div class="gup-O-list__item">
            <kal-button (click)="save()"
                        [disabled]="loading"
                        kalTheme="primary">
                Valider
            </kal-button>
        </div>

    </div>

</div>
